// accordions
const accordionGroups = document.querySelectorAll(".accordion-group");
console.log('accordiongroups', accordionGroups);

accordionGroups.forEach((group) => {
  group.querySelectorAll(".accordion-item").forEach((child, i) => {
    child
      .querySelector(".accordion-toggle")
      .addEventListener("click", function (e) {
        e.preventDefault();
        
        console.log('child', child);
        // If already active, do nothing (or close it if you want toggle behavior)
        if (child.classList.contains("active")) {
          // Groups marked data-collapsible let the open item be closed again.
          if (group.hasAttribute("data-collapsible")) {
            child.classList.remove("active");
            child.querySelector(".accordion-content").style.height = "0px";
          }
          return;
        }
        
        // toggle the accordion-content
        const accordionContent = child.querySelector(".accordion-content");
        accordionContent.style.height = accordionContent.scrollHeight + "px";

        // Close all other accordion items
        group.querySelectorAll(".accordion-item").forEach((sibling, j) => {
          if (i !== j) {
            sibling.classList.remove("active");
            sibling.querySelector(".accordion-content").style.height = "0px";
          }
        });

        // Open current accordion item
        child.classList.add("active");
      });
  });
});
